<template>
  <v-footer id="main-footer" absolute height="42" style="background:transparent">
    <v-layout row justify-end class="mr-3">

    <div>
      <span v-for="link in links" :key="link.name">
        <router-link :to="link.Link" class="font-weight-light footer-links ml-2">{{ link.name }}</router-link>
      </span>
    </div>
    <!--<v-spacer/>-->
    <span class="font-weight-light copyright ml-4 mr-4">
      &copy;
      {{ (new Date()).getFullYear() }}
      Lingo AV
    </span>

    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: 'lingo_main_footer',
  data: () => ({
    links: [
      { name: 'Terms of Service', Link: '/terms' },
      { name: 'Privacy Policy', Link: '/legal' },
      { name: 'Cookie Policy', Link: '/cookiePolicy' }
    ]
  })
}
</script>

<style>
#main-footer {
  z-index: 0;
}

.footer-links {
	color:unset;
}
</style>
